import { Box, Modal, Paper, Typography } from '@mui/material'
import { UserData } from '../UserPage/useUserPage'
import { FormEventHandler, Fragment, useState } from 'react'
import SelectOrgs from '@components/SelectOrgs'
import { LoadingButton } from '@mui/lab'
import PublishIcon from '@mui/icons-material/Publish'
import { SnackbarProvider } from 'notistack'
import PersonalUserToOrgUserForm from './PersonalUserToOrgUserForm'
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork'
import SelectRole, { RoleName } from '@components/SelectRole'

type EditUserModalProps = {
    user: UserData | null
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    submit: FormEventHandler<HTMLFormElement>
    setNewOrg: React.Dispatch<React.SetStateAction<string | undefined>>
    newRole?: RoleName
    setNewRole: React.Dispatch<React.SetStateAction<RoleName | undefined>>
}

export default function EditUserModal(props: EditUserModalProps) {
    const [loading, setLoading] = useState(false)
    const [openPersonalTransfer, setOpenPersonalTransfer] = useState(false)
    if (!props.user) return <></>

    const { adminProfile, accountProfile } = props.user
    // const { adminProfile, accountProfile, mpProfile } = props.user
    // const { mpOrderCount } = mpProfile

    const { open, setOpen, setNewOrg, submit, setNewRole } = props

    if (!adminProfile && !accountProfile) return <></>

    return (
        <Fragment>
            <Modal
                open={open}
                onClose={() => {
                    setLoading(false)
                    setOpen(false)
                }}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Paper
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography id="modal-title" variant="h3">
                        Edit User
                    </Typography>
                    <Typography id="modal-description" variant="subtitle1">
                        Make changes to this user.
                    </Typography>
                    <form
                        onSubmit={async (e) => {
                            setLoading(true)
                            await Promise.resolve(submit(e)).then(() => {
                                setLoading(false)
                            })
                        }}
                    >
                        {adminProfile && adminProfile.created_date ? (
                            <Fragment>
                                <Typography id="modal-title" variant="h4">
                                    Admin
                                </Typography>
                                <SelectOrgs
                                    selectedOrg={adminProfile.org_id ?? ''}
                                    setSelectedOrg={setNewOrg}
                                    setShowForm={setOpen}
                                />
                                <SelectRole
                                    setSelectedRole={setNewRole}
                                    defaultValue={adminProfile.role as RoleName}
                                    sx={{
                                        marginTop: 1,
                                        marginBottom: 1,
                                    }}
                                />
                            </Fragment>
                        ) : (
                            <Box>
                                <LoadingButton
                                    sx={{ marginTop: '16px' }}
                                    startIcon={<AddHomeWorkIcon />}
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                        setOpenPersonalTransfer(true)
                                    }}
                                    loading={loading}
                                >
                                    Add User to Org
                                </LoadingButton>
                            </Box>
                        )}
                        <LoadingButton
                            sx={{ marginTop: '16px' }}
                            startIcon={<PublishIcon />}
                            size="small"
                            variant="contained"
                            type="submit"
                            loading={loading}
                        >
                            Apply Changes
                        </LoadingButton>
                    </form>
                </Paper>
            </Modal>
            <Modal
                open={openPersonalTransfer}
                onClose={() => {
                    setOpenPersonalTransfer(false)
                }}
            >
                <Paper
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <PersonalUserToOrgUserForm userId={accountProfile.id} />
                </Paper>
            </Modal>
            <SnackbarProvider
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            />
        </Fragment>
    )
}
